'use strict';

import Component from 'generic.basecomponent';
import $ from 'jquery';
import app from 'app-instance';

export default class BasketInfo extends Component {
    constructor(el) {
        super(el);
        this.basketInfoUrl = '/api/shoppingcart/get';
        this.totalCountSelector = '.js-basket-info-total-count';
        this.init();
    }

    init() {
        this.totalCount = this.container.querySelector(this.totalCountSelector);
        if (!this.totalCount) {
            return;
        }

        this.loadInitial();
        app.addListener('basket', this.onBasketUpdate.bind(this));
    }

    onBasketUpdate(basket) {
        this.updateInfo(basket)
    }

    updateInfo(basket) {
        this.totalCount.innerHTML = basket.TotalCount;
    }

    loadInitial() {
        return this.doBasketInfoRequest().then((result) => {
            this.updateInfo(result);
        }, (error) => {
            console.log(error);
        })
    }

    doBasketInfoRequest(params = {}) {
        return new Promise((resolve, reject) => {
            $.ajax({
                method: "get",
                url: this.getUrl(params),
            }).done((response) => {
                resolve(response);
            }).fail((error) => {
                reject(error);
            });
        });
    }

    getUrl(params) {
        let paramsString = Object.keys(params).map(key => `${key}=${params[key]}`).join('&');
        return `${this.basketInfoUrl}` + (paramsString !== '' ? `?${paramsString}` : '');
    }
}

BasketInfo.id = 0;



// WEBPACK FOOTER //
// ./app/components/shop/js/generic.basket-info.js